import { useMetadataPref } from '#hooks/useMetadataPref';
import { useSelector } from '#redux';

import { tripulacion } from './tripulacionLogica';
import type { Tripulante } from './tripulacionLogica';

/** La tripulación del presupuesto abierto (vacía si no está en la nube). */
export function useTripulacion(): Tripulante[] {
  const [cloudFileId] = useMetadataPref('cloudFileId');
  const allFiles = useSelector(state => state.budgetfiles.allFiles || []);
  const userData = useSelector(state => state.user.data);
  const archivo = allFiles.find(
    f => 'cloudFileId' in f && f.cloudFileId === cloudFileId,
  );
  if (!archivo || !('usersWithAccess' in archivo)) {
    return [];
  }
  const miId = userData && 'userId' in userData ? userData.userId : null;
  return tripulacion(archivo.usersWithAccess ?? [], miId ?? null);
}
